
















import { Component, Vue } from "vue-property-decorator";
import { SaveServiceTaskTypeCommand } from "@/servicetask/api/service-tasks-api";
import ServiceTasksForm from "../../ui/components/ServiceTasksForm.vue";

@Component({
  components: {
    ServiceTasksForm
  }
})
export default class ServiceTasksCreatePage extends Vue {
  taskType: SaveServiceTaskTypeCommand = {
    name: ""
  };

  saving = false;

  goListPage() {
    this.$router.push({ path: "/admin/service-tasks" });
  }

  // APIへ値の保存 (ServiceTaskForm内のメソッドにまかせる)
  async saveServiceTask() {
    this.saving = true;
    const form = this.$refs["form"] as ServiceTasksForm;
    await form
      .submit()
      .then(() => {
        this.goListPage();
      })
      .catch((e: Error) => {
        alert(e.message);
      })
      .finally(() => {
        this.saving = false;
      });
  }
}
